import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const referralCodeAtom = atomWithStorage<string>("referralCode", "");

export const useReferralCode = () => {
  const [referralCode, setReferralCode] = useAtom(referralCodeAtom);

  return {
    referralCode,
    setReferralCode,
  };
};
